<template>
  <v-layout>
    <v-store-user-info/>
    <h1>
      <span id="subscriptions-title">
        {{ $t('abtProductOverview.title') }}
      </span>
    </h1>
    <product-filter-bar>
      <product-filter
        id="product-filter-region"
        :placeholder="$t('productOverview.selectRegions')"
        :entities="regionsWithProducts"
        :entity-selection="selectedRegions"
        :multiple="true"
        group-name="regionFilter"
        @entitySelectionChanged="setRegionSelection"/>
    </product-filter-bar>
    <product-overview-component @revealProductDetail="onRevealProductDetail"/>
    <product-detail-modal v-if="detailsProduct && detailsCustomerGroup"
                          @close="resetConfiguration"/>
  </v-layout>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import VLayout from '../../layouts/Default'
import VStoreUserInfo from '../../components/user/StoreUserInfo'
import ProductDetailModal from '../../components/modals/ProductDetail'
import ProductFilterBar from '../../components/ProductFilterBar'
import ProductOverviewComponent from '../../components/ProductOverview'
import bodyClassMixin from '../../mixins/body-class'
import {
  SET_SELECTED_PRODUCT,
  SET_SELECTED_CUSTOMER_GROUP,
  SET_SELECTED_TERM,
  RESET
} from '../../store/modules/configuration/mutation-types'
import { AbtShop } from '../../store/modules/shop/types'
import ProductFilter from '../../components/ProductFilter'
import {applyCriteriaFromUrlParameters} from '../../deeplink'

export default {
  name: 'AbtProductOverviewPage',
  components: {
    ProductFilter,
    VLayout,
    VStoreUserInfo,
    ProductDetailModal,
    ProductFilterBar,
    ProductOverviewComponent
  },
  mixins: [
    bodyClassMixin
  ],
  data () {
    return {
      preSelection: null
    }
  },
  computed: {
    ...mapState({
      selectedRegions: state => state.selection.selectedFilterEntities.regions,
      detailsProduct: state => state.configuration.selectedProduct
    }),
    ...mapGetters('selection', [
      'sortedRegions'
    ]),
    ...mapGetters('shop', ['shopFilterEntityIds']),
    ...mapGetters('configuration', ['customerGroupToUseForConfiguration']),
    detailsCustomerGroup () {
      return this.customerGroupToUseForConfiguration
    },
    regionSelectionModalTriggerTitle () {
      return this.selectedRegions.length === 0
        ? this.$t('productOverview.selectRegion')
        : this.$t('productOverview.changeRegionSelection')
    },
    regionsWithProducts: function () {
      return this.sortedRegions.filter(region => region.nrOfProductConfigurations > 0)
    },
    regionNames () {
      const names = this.selectedRegions
        .map(region => region.title)
        .sort((a, b) => a.localeCompare(b))
      const nameString = [names.slice(0, -1).join(', '), names.slice(-1)[0]]
        .join(names.length < 2 ? '' : ` ${this.$t('generic.and')} `)

      return nameString.length > 0 ? this.$t('generic.for') + ' ' + nameString : nameString
    }
  },
  watch: {
    selectedRegions: function () {
      this.$store.dispatch('selection/fetchFilters')
      this.$store.dispatch('selection/fetchProductConfigurations')
    }
  },
  mounted: async function () {
    await this.$store.dispatch('shop/switchShop', new AbtShop())
    await this.$store.dispatch('shop/fetchBasicFilters')
    await this.$store.dispatch('selection/fetchFilters')
    await this.$store.dispatch('selection/fetchRegions')
    applyCriteriaFromUrlParameters(this.$route.query)
    this.$store.dispatch('selection/fetchProductConfigurations')
  },
  methods: {
    ...mapActions('selection', ['setRegionSelection']),
    onRevealProductDetail: function (product, customerGroup, term = null) {
      this.$store.commit('configuration/' + SET_SELECTED_PRODUCT, product)
      this.$store.commit('configuration/' + SET_SELECTED_CUSTOMER_GROUP, customerGroup)
      this.$store.commit('configuration/' + SET_SELECTED_TERM, term)
    },
    resetConfiguration: function () {
      this.$store.commit('configuration/' + RESET)
    },
    regionSelectionChanged: function () {
      this.$store.dispatch('selection/fetchFilters')
      this.$store.dispatch('selection/fetchProductConfigurations')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/abt/AbtProductOverview.vue